import { SxProps, useTheme } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      position: 'static' as const,
      '& .MuiBackdrop-root': {
        display: 'none',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '14px',
      position: 'fixed',
      right: 40,
      bottom: 124,
      top: 'auto',
      left: 'auto',
      width: 280,
      maxWidth: '100%',
      height: 'fit-content',
      overflow: 'hidden',
      backdropFilter: 'blur(12px)',
      backgroundColor: colors.black_99,
      border: '1px solid rgba(255, 255, 255, 0.25)',
      borderRadius: '24px',

      '&:focus-visible': {
        outline: 'none',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        right: 20,
        bottom: 76,
        width: isMobileOnly ? 404 : 'calc(100vw - 40px)',
        maxWidth: '100%',
        padding: '12px 16px',
        borderRadius: '20px',
      },
      ...(isMobileOnly
        ? {
            right: 20,
            bottom: 76,
            width: 404,
            maxWidth: '100%',
            padding: '12px 16px',
            borderRadius: '20px',
          }
        : {}),
    } as SxProps,
    closeIcon: {
      position: 'absolute',
      top: 14,
      right: 14,
      color: colors.white_60,
      fontSize: 20,
      cursor: 'pointer',
      zIndex: 2,

      '&:hover': {
        color: colors.white,
      },
    },
    title: {
      fontFamily: 'var(--primary-font-bold)',
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 1,
      color: colors.white,
      marginBottom: '10px',
    },
    scrollWrapper: {
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: 'calc(100vh - 320px)',
      scrollbarWidth: 'none' as const,
      msOverflowStyle: 'none' as const,

      '&::-webkit-scrollbar': {
        display: 'none',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        maxHeight: 'calc(100dvh - 240px)',
      },
    } as SxProps,
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '6px',
    },
    card: {
      position: 'relative',
      borderRadius: '10px',
      overflow: 'hidden',
      cursor: 'pointer',
      aspectRatio: '1',
      '&:hover': {
        opacity: 0.85,
      },
    } as SxProps,
    cardImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    cardPlaceholder: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255,255,255,0.08)',
    },
    cardLabel: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '6px 8px',
      background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
      color: colors.white,
      fontFamily: 'var(--primary-font-bold)',
      fontWeight: 600,
      fontSize: 10,
      lineHeight: 1.25,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  };
};
